// 兼容性API服务模块 - 保持向后兼容
// 新的API服务请使用 /services/api/ 目录下的模块化服务

import { authAPI } from './api/auth';

// 重新导出认证相关API，保持向后兼容
export const apiService = {
  login: authAPI.login.bind(authAPI),
  getUserInfo: authAPI.getCurrentUser.bind(authAPI),
  logout: authAPI.logout.bind(authAPI),
  isAuthenticated: authAPI.isAuthenticated.bind(authAPI),
  validateToken: authAPI.validateToken.bind(authAPI),
};

// 重新导出类型，保持向后兼容
export type { LoginRequest, LoginResponse, UserResponse } from '@/types/api';
